import { render, staticRenderFns } from "./CO2Meter.vue?vue&type=template&id=3150cd0f&scoped=true&"
import script from "./CO2Meter.vue?vue&type=script&lang=js&"
export * from "./CO2Meter.vue?vue&type=script&lang=js&"
import style0 from "./CO2Meter.vue?vue&type=style&index=0&id=3150cd0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3150cd0f",
  null
  
)

export default component.exports